module.exports = __webpack_public_path__ + "img/medal.e148ad4d.png";